




















































































import {Vue, Component} from "vue-property-decorator";
import axiosInstance from "../../../../axios";
// @ts-ignore
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/material_blue.css';
import { Russian } from "flatpickr/dist/l10n/ru.js";
import * as dayjs from 'dayjs'
import {Notification} from "../../../../../types/notifications";
import Activity = Notification.Activity;
import {Statistic} from "../../../../../types/statistic";
import {Tool} from "../../../../helpers/Tool";
import Invites from "./Invites.vue";
import Detailed from "./Detailed.vue";

@Component({
    components: {Detailed, Invites, flatPickr},
})

export default class Platform extends Vue {
    private platformData: Statistic.PlatformTotal|null = null
    private date: string = '';
    private config: any = {
        locale: Russian,
        dateFormat: 'Y.m.d',
        mode: 'range',
        defaultDate: this.date,
    };
    private dateFrom: string = '';
    private dateTo: string = '';

    private tabsIdsMap = {
        PLATFORM: 1,
        INVITES: 2,
        DETAILED: 3
    };

    private tabs: Array<Statistic.PlatformTab> = [
        {
            name: 'Платформа',
            isActive: true,
            id: this.tabsIdsMap.PLATFORM
        },
        {
            name: 'Теги/Коды',
            isActive: false,
            id: this.tabsIdsMap.INVITES
        },
        {
            name: 'Подробнее',
            isActive: false,
            id: this.tabsIdsMap.DETAILED
        }
    ];

    private detailedTagName: string|null = null;
    private detailedCodeName: string|null = null;

    mounted(): void {
        this.getTotalInfo();

        const urlParams = (new URL(window.location.href)).searchParams;
        this.detailedCodeName = urlParams.get('code');
        this.detailedTagName = urlParams.get('tag');
        if (this.detailedCodeName || this.detailedTagName) {
            this.changeTab(this.tabsIdsMap.DETAILED);
        }
    }

    /**
     * Текущий таб
     * @private
     */
    private get activeTab(): Statistic.PlatformTab
    {
        return this.tabs.filter(tab => tab.isActive)[0];
    }

    /**
     * Список игр с контент-паками
     * @private
     */
    private getTotalInfo(): Promise<{[key: number]: Activity}>
    {
        const params = new URLSearchParams();
        if (this.dateFrom) {
            params.append('date_from', this.dateFrom);
        }
        if (this.dateTo) {
            params.append('date_to', this.dateTo);
        }

        return new Promise((resolve, reject) => {
            axiosInstance.get(`/statistics/platform`, {params})
                .then(response => {
                    if (typeof response.data.errors === 'undefined') {
                        const data: Array<Statistic.PlatformTotal> = response.data.response.data;
                        if (typeof data[0] !== 'undefined') {
                            this.platformData = data[0];
                        }
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                }).catch(error => {
                reject(error);
            });
        });
    }

    /**
     * Получить минуты из секунд
     * @param sec
     * @private
     */
    private getMinutes(sec: number): number
    {
        return Tool.getMinutesFromSeconds(sec);
    }

    /**
     * Изменить дату в календаре
     * @param selectedDates
     * @private
     */
    private changeDate(selectedDates: any): void
    {
        // @ts-ignore
        this.dateFrom = typeof selectedDates[0] !== 'undefined' ? dayjs(selectedDates[0]).format('YYYYMMDD') : '';
        // @ts-ignore
        this.dateTo = typeof selectedDates[1] !== 'undefined' ? dayjs(selectedDates[1]).format('YYYYMMDD') : '';

        this.getTotalInfo();
    }

    /**
     * Очистить дату в календаре
     * @private
     */
    private clearDate(): void
    {
        this.dateFrom = '';
        this.dateTo = '';
        this.date = '';

        this.getTotalInfo();
    }

    /**
     * Переключить таб
     * @param id
     * @private
     */
    private changeTab(id: number): void
    {
        this.tabs.forEach(tab => {
           tab.isActive = false;
           if (tab.id === id) {
               tab.isActive = true;
           }
        });
    }

    /**
     * Получить подробную информацию по тегу
     * @param name
     * @private
     */
    private getDetailedTag(name: string): void
    {
        this.detailedTagName = encodeURIComponent(name);
        const url = new URL(window.location.href);
        url.searchParams.set('tag', this.detailedTagName);
        window.location.href = url.toString();
    }

    /**
     * Получить подробную информацию по тегу
     * @param name
     * @private
     */
    private getDetailedCode(name: string): void
    {
        this.detailedCodeName = encodeURIComponent(name);
        const url = new URL(window.location.href);
        url.searchParams.set('code', this.detailedCodeName);
        window.location.href = url.toString();
    }

    /**
     * Назад к списку тэгов и инвайтов
     * @private
     */
    private backToTagsList(): void
    {
        this.detailedTagName = null;
        this.detailedCodeName = null;
        this.changeTab(this.tabsIdsMap.INVITES);
        const url = new URL(window.location.href);
        url.searchParams.delete('code');
        url.searchParams.delete('tag');
        window.location.href = url.toString();
    }
}
